import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import "./Layout.css";

function Layout({ usuario }) {
  return (
    <div className="layout">
      <Header />
      <Sidebar rol={usuario.rol} />
      <main className="main-content">
        <Outlet context={"https://lider.tutorandy.xyz/php"} id={usuario.id}/>
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
